<template>
  <span class="actions">
    <span class="increase" @click="$emit('increase')">
      <img :src="getIcon('increase.svg')" alt="" />
    </span>
    <span
      class="decrease"
      @click="$emit('decrease')"
      :class="{ disabled: disabled }"
    >
      <img :src="getIcon('decrease.svg')" alt="" />
    </span>
  </span>
</template>

<script>
export default {
  name: 'InputAmountButtons',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
$color-primary: #196cae;

.actions {
  height: 100%;
  width: 30px;
  display: flex;
  flex-direction: column;

  .decrease {
    background: rgba($color-primary, 0.75);

    &.disabled {
      border-top-right-radius: 0 !important;
      background-color: rgba($color-primary, 0.25);
    }
  }

  > * {
    height: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;

    &:first-child {
      background-color: $color-primary;
    }
  }
}
</style>
